import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Images from "assets/images";
import Card from "components/visitCommon/Card";
import StepScreenContainer from "components/visitCommon/StepScreenContainer";
import MedicalAssistant from "components/MedicalAssistant/MedicalAssistant";
import { Icon } from "stories/Icons";
import {
  referral_source_code,
  step_status,
} from "helpers/enum";
import useVisitStepChange from "hooks/useVisitStepChange";
import { dermaVisitFlowReducers } from "reducers/dermatology/dermaVisitFlowReducer";
import { useApiMutation } from "hooks/useApiMutation";
import { updateReferralSourceAction } from "api/actions/UserActions";
import { useCurrentUser } from "hooks/useCurrentUser";
import { setUserDetails } from "reducers/currentUserReducer";
import { useDermatologyVisitFlow } from "hooks/useVisitFlow";

const referralOptions = [
  {
    label: "Google",
    value: "google",
    renderIcon: () => <Icon name="google" className="w-10 h-10" />,
  },
  {
    label: "Instagram",
    value: "instagram",
    renderIcon: () => <img src={Images.InstagramIcon} alt="Instagram" />,
  },
  {
    label: "Facebook",
    value: "facebook",
    renderIcon: () => <img src={Images.FacebookIcon} alt="Facebook" />,
  },
  {
    label: "TikTok",
    value: "tiktok",
    renderIcon: () => <img src={Images.TikTokIcon} alt="TikTok" />,
  },
  {
    label: "Doctor's Referral",
    value: "doctor_referral",
    renderIcon: () => <img src={Images.DoctorReferralIcon} alt="Doctor Referral" />,
  },
  {
    label: "Other",
    value: "other",
    renderIcon: () => <img src={Images.OthersIcon} alt="Other" />,
  },
];

function ReferralSourceForDerm() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [selectedSource, setSelectedSource] = useState(null);
  const { rightButtonClickRef } = useVisitStepChange();
  const { userDetails } = useCurrentUser();
  const { incompleteData } = useDermatologyVisitFlow();
  const { mutate: callUpdateReferralSource } = useApiMutation(
    updateReferralSourceAction
  );

  rightButtonClickRef.current = onRightButtonClick;

  useEffect(() => {
    const rawReferralSource = userDetails?.referral_source;
    if (rawReferralSource == null) {
      setSelectedSource(null);
      return;
    }
    if (referralOptions.some((option) => option.value === rawReferralSource)) {
      setSelectedSource(rawReferralSource);
    }
  }, [userDetails?.referral_source]);

  useEffect(() => {
    dispatch(
      dermaVisitFlowReducers.referral_source({
        isValid: true,
      })
    );
  }, [dispatch]);

  function onRightButtonClick() {
    if (!selectedSource) {
      dispatch(
        dermaVisitFlowReducers.referral_source({
          status: step_status.upcoming,
          value: null,
          isValid: true,
        })
      );
      history.goBack();
      return;
    }
    callUpdateReferralSource({
      referral_source: referral_source_code[selectedSource],
      referral_source_visit_id: incompleteData?.id ?? null,
    }).then((response) => {
      if (response?.error !== true) {
        dispatch(
          setUserDetails({
            userDetails: {
              ...userDetails,
              referral_source: selectedSource,
            },
          })
        );
        dispatch(
          dermaVisitFlowReducers.referral_source({
            value: selectedSource,
            status: step_status.completed,
          })
        );
        history.goBack();
      }
    });
  }

  return (
    <StepScreenContainer align={"start"}>
      <MedicalAssistant content={<p>How did you hear about us? (Optional)</p>} />
      <Card>
        <div className="space-y-6">
          {referralOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => setSelectedSource(option.value)}
              className={`w-full p-6 border rounded-xl flex items-center justify-between ${
                selectedSource === option.value ? "border-orange" : "border-borderColor"
              }`}
            >
              <div className="flex items-center">
                <div className="w-10 h-10 flex items-center justify-center">
                  {option.renderIcon ? (
                    option.renderIcon()
                  ) : (
                    <div className="w-9 h-9 rounded-full bg-indigo bg-opacity-10" />
                  )}
                </div>
                <p className="pl-6 text-2xl font-medium text-indigo">{option.label}</p>
              </div>
              <img
                className="w-10 h-10"
                src={
                  selectedSource === option.value
                    ? Images.radioChecked
                    : Images.uncheckedCircle
                }
                alt="radio"
              />
            </button>
          ))}
        </div>
      </Card>
    </StepScreenContainer>
  );
}

export default ReferralSourceForDerm;
